import { addToCart, getCartList, updateCart } from '@/api/cart'
import { IAddToCartAction, ICartItem, ICartList, IUpdateCartAction } from '@/interfaces/cart'
import Vue from 'vue'
import Vuex, { GetterTree, MutationTree, ActionTree } from 'vuex'
import * as Event from '@/utils/sendEvent'
import { CartState, CartType } from './types'

Vue.use(Vuex)

const getDefaultState = (): CartState => {
  return {
    cartList: [],
    cartAmount: 0,
    cartCheckedCount: 0,
    buyMoreListCart: [],
    buyMoreListOrder: [],
    orderInfo: null,
    noDeliverFeePrice: 698,
    recList: []
  }
}
const state = getDefaultState()

const getters: GetterTree<CartState, any> = {
  cartList: state => state.cartList,
  cartAmount: state => state.cartAmount,
  cartCheckedCount: state => state.cartCheckedCount,
  buyMoreListCart: state => state.buyMoreListCart,
  buyMoreListOrder: state => state.buyMoreListOrder,
  orderInfo: state => state.orderInfo,
  noDeliverFeePrice: state => state.noDeliverFeePrice,
  recList: state => state.recList,
  checkoutItemsString: state => {
    if (state.orderInfo === null) return ''
    else { return state.orderInfo.showstr || '' }
  }
}

const mutations: MutationTree<CartState> = {
  SET_CART_COUNT (state, count) {
    state.cartCheckedCount = count
  },
  SET_ORDER_INFO (state, orderInfo) {
    state.orderInfo = orderInfo
  },
  SET_CART_LIST (state, payload) {
    // Replace value which is set
    if (payload) {
      state.cartList = payload.cart_list || state.cartList
      state.cartAmount = payload.amount !== undefined ? payload.amount : state.cartAmount
      state.cartCheckedCount = payload.count !== undefined ? payload.count : state.cartCheckedCount
      state.buyMoreListCart = payload.buymore_list_cart || state.buyMoreListCart
      state.buyMoreListOrder = payload.buymore_list_order || state.buyMoreListOrder
      state.recList = payload.rec_list || state.recList
      state.noDeliverFeePrice = payload.no_deliver_fee_price !== undefined ? payload.no_deliver_fee_price : state.noDeliverFeePrice
    } else {
      const defaultState = getDefaultState()
      state.cartList = defaultState.cartList
      state.cartAmount = defaultState.cartAmount
      state.cartCheckedCount = defaultState.cartCheckedCount
      state.buyMoreListCart = defaultState.buyMoreListCart
      state.buyMoreListOrder = defaultState.buyMoreListOrder
      state.recList = defaultState.recList
      state.noDeliverFeePrice = defaultState.noDeliverFeePrice
    }
  },
  SET_CART_AMOUNT (state, amount) {
    state.cartAmount = amount
  },
  RESET_CART (state) {
    const defaultState = getDefaultState()
    state.cartList = defaultState.cartList
    state.cartAmount = defaultState.cartAmount
    state.cartCheckedCount = defaultState.cartCheckedCount
    state.buyMoreListCart = defaultState.buyMoreListCart
    state.buyMoreListOrder = defaultState.buyMoreListOrder
    state.recList = defaultState.recList
    state.noDeliverFeePrice = defaultState.noDeliverFeePrice
    state.orderInfo = defaultState.orderInfo
  }
}

const actions: ActionTree<CartState, any> = {
  async GET_CART_LIST ({ commit, rootGetters }, type: number) {
    try {
      const { data } = await getCartList({ token: rootGetters.token, type })
      // return Promise.resolve(cartListData)
      if (data.flag === 0) {
        const cartListData = data.data

        if (type === CartType.count) {
          commit('SET_CART_COUNT', cartListData.count || 0)
        } else if (type === CartType.cart) {
          commit('SET_CART_LIST', cartListData)
          commit('SET_ORDER_INFO', cartListData.orderinfo)
        } else if (type === CartType.checkout) {
          if (cartListData.orderinfo) {
            if (cartListData.orderinfo.success === 1) {
              commit('SET_CART_LIST', cartListData)
            } else if (cartListData.orderinfo.success === 0) {
              commit('logger/PUSH_LOG', 'orderInfo failed')
              commit('logger/PUSH_LOG', cartListData.orderinfo)
            }
          }

          commit('SET_ORDER_INFO', cartListData.orderinfo)
          commit('SET_COIN_LEFT', cartListData.coin_left)
          commit('SET_COIN_VALUE', cartListData.coin_value)
          commit('SET_NU_COIN', parseInt(cartListData.nucoin) || 0)
        }
        return Promise.resolve(data)
      } else if (data.flag === 2) {
        return Promise.resolve(data)
      } else {
        throw new Error(data.msg)
      }
    } catch (error) {
      console.log(error)
      return Promise.reject(error)
    }
  },
  async ADD_TO_CART ({ commit }, payload: IAddToCartAction) {
    try {
      commit('logger/PUSH_LOG', `Add ${payload.variant_id}, ${payload.qty}`)
      commit('logger/PUSH_LOG', { addToCartRequest: payload })

      const { data } = await addToCart(payload)
      if (data.flag === 1) {
        throw data.msg
      } else if (data.flag === 0) {
        const cartListData = data.data
        if (payload.return_cart === 1) {
          commit('SET_CART_LIST', cartListData)
        }

        (this as any)._vm.$gtag.event('加入購物車', {
          event_category: '購物車',
          event_label: payload.variant_id,
          value: payload.qty
        })
        Event.addToCart(payload.variant_id, payload.title, payload.qty)
        commit('SET_CART_COUNT', cartListData.count)
        return Promise.resolve(data)
      } else if (data.flag === 2) {
        return Promise.resolve(data)
      }
    } catch (error) {
      console.log(error)
      return Promise.reject(error)
    }
  },
  async UPDATE_CART ({ commit }, payload: IUpdateCartAction) {
    try {
      const deleted = payload.deleted
      const { data } = await updateCart(payload.data)
      const cartListData = data.data
      const responseCartList = cartListData.cart_list
      let tempCartList = state.cartList || [] as ICartItem[]

      if (data.flag === 0) {
        if (deleted) {
          tempCartList = responseCartList
        } else {
          // Get the all cart list
          if (responseCartList.length > 1) {
            tempCartList = responseCartList
          } else if (responseCartList.length === 1) {
            const target = tempCartList[tempCartList.findIndex(item => item.id === responseCartList[0].id)]
            Object.assign(target, responseCartList[0])
          }
        }
        commit('SET_CART_LIST', {
          cart_list: tempCartList,
          amount: cartListData.amount,
          count: cartListData.count
        })
        return Promise.resolve(data)
      } else if (data.flag === 1) {
        // no cart updated
        commit('SET_CART_LIST', {
          cart_list: tempCartList,
          amount: cartListData.amount,
          count: cartListData.count
        })
        return Promise.resolve(data)
      } else if (data.flag === 2) {
        return Promise.resolve(data)
      } else {
        return Promise.reject(data.msg)
      }
    } catch (error) {
      console.log(error)
      return Promise.reject(error)
    }
  }
}

export default {
  namespaced: false,
  state,
  getters,
  mutations,
  actions
}
